import React, { useEffect } from 'react'
import { MetricTimeUnit } from 'enums'

import { createMetric } from 'utils/runSearchUtil'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import { getMetricSeries } from 'utils/measureTypeUtil'
import { getMeasureType } from 'utils/viewOptionUtil'
import { useAppDispatch } from 'app/hooks'
import { InsightContentSettingType } from 'components/insightContent/types'
import { getSparklineMetricTimeUnit } from 'utils/sparklineMetricTimeUnit'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

const createSearch = (detailSetting: InsightContentSettingType, isAudienceQuery: boolean) => {
  const { filter, precision, topicId, selectionFilter, viewOption } = detailSetting
  if (!selectionFilter) {
    return null
  }

  const timeUnits = [MetricTimeUnit.ALL, getSparklineMetricTimeUnit(filter?.publishedDate)]
  const option = {
    forceNotScale: false,
    isAudienceQuery
  }
  const measure = getMeasureType(viewOption)[0]

  return createMetric(
    -1,
    '',
    precision,
    [topicId],
    selectionFilter,
    getMetricSeries(measure),
    timeUnits,
    option
  )
}

const RunSearchEffect = ({
  detailSetting,
  isAudienceQuery,
  children
}: {
  detailSetting: InsightContentSettingType
  isAudienceQuery: boolean
  children: any
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    const searches = createSearch(detailSetting, isAudienceQuery)

    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.NAME_MEASURE_BY,
        searches: [searches!],
        timestamp: refreshTimestamp
      })
    )
  }, [dispatch, detailSetting, isAudienceQuery, refreshTimestamp])

  return <>{children}</>
}

export default RunSearchEffect
